// Accès à l'onboarding « Par quoi commencer ».
//
// OUVERT À TOUS LES CLIENTS CONNECTÉS. Décision Charly 22/07/2026 : « tous les clients
// actuels doivent aussi avoir accès à la page démarrer ». L'entrée de menu « Démarrer » et
// la page /demarrage sont donc accessibles à tout compte authentifié (payant ou gratuit,
// nouveau ou établi).
//
// À NE PAS CONFONDRE avec la REDIRECTION automatique d'atterrissage (router/routes/index.js) :
// celle-ci reste limitée aux NOUVEAUX inscrits (ni propriétaire en gestion « PIN », ni futur
// investisseur « FIN »), pour ne pas détourner un client établi de son écran habituel
// (Locataires / simulateur). Ici on ne gère QUE la visibilité et l'accès de la page.
export function isOnboardingEnabled() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null

  // Tout compte authentifié (profil Keycloak lisible) a accès à « Démarrer ».
  return !!(tp && tp.rl_profile)
}
